import { Box, Typography, Stack } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import CakeIcon from "@mui/icons-material/Cake";
import LanguageIcon from "@mui/icons-material/Language";

const Breadcrumbs = ({
  activeTab,
  email,
  phoneNumber,
  siteId,
  participantId,
  nameInitials,
  trial,
  birthDate,
  preferredLanguage = "en",
}) => {
  const LANGUAGE_LABELS = { en: "English", es: "Spanish", de: "German" };

  let user_data = "";
  try {
    user_data = JSON.parse(localStorage.getItem("user_data"));
  } catch (error) {
    console.error("Error parsing JSON data:", error);
  }

  let role;
  try {
    role = user_data.role;
  } catch (error) {
    console.error("Error", error);
  }

  return (
    <Box
      position="sticky"
      top={0}
      bgcolor="#f1f1f1"
      px={2}
      py={1}
      zIndex={99}
      display="flex"
      justifyContent="space-between"
      flexWrap="wrap"
    >
      {!!activeTab && (
        <Stack direction="row" spacing={2} flexWrap="wrap" alignItems="center">
          {!!(siteId && participantId && nameInitials && trial) && (
            <Stack direction="row" spacing={1} alignItems="center">
              <CreditCardIcon fontSize="small" sx={{ color: "#EE295D" }} />
              <Typography variant="body2">{`${siteId}-${participantId} (${nameInitials}) [${trial}]`}</Typography>
            </Stack>
          )}

          {role !== "Reviewer" &&
            role !== "CRO Admin" &&
            role !== "Cro_coordinator" &&
            role !== "Data Manager" && (
              <>
                {!!email && (
                  <Stack direction="row" spacing={1} alignItems="center">
                    <EmailOutlinedIcon fontSize="small" sx={{ color: "#EE295D" }} />
                    <Typography variant="body2">{email}</Typography>
                  </Stack>
                )}

                {!!phoneNumber && (
                  <Stack direction="row" spacing={1} alignItems="center">
                    <PhoneInTalkOutlinedIcon fontSize="small" sx={{ color: "#EE295D" }} />
                    <Typography variant="body2">{phoneNumber}</Typography>
                  </Stack>
                )}

                {!!birthDate && (
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CakeIcon fontSize="small" sx={{ color: "#EE295D" }} />
                    <Typography variant="body2">{birthDate}</Typography>
                  </Stack>
                )}

                {!!preferredLanguage && (
                  <Stack direction="row" spacing={1} alignItems="center">
                    <LanguageIcon fontSize="small" sx={{ color: "#EE295D" }} />
                    <Typography variant="body2">
                      {LANGUAGE_LABELS[preferredLanguage] ?? preferredLanguage}
                    </Typography>
                  </Stack>
                )}
              </>
            )}
        </Stack>
      )}
    </Box>
  );
};

export default Breadcrumbs;
